export default __webpack_public_path__ + "static/media/promo.f509e159.svg";